const generateTwitterShareLink = (urlToShare, invitationMessage) =>
  `https://twitter.com/intent/tweet?url=${encodeURIComponent(urlToShare)}&text=${encodeURIComponent(
    invitationMessage
  )}`;

export default generateTwitterShareLink;
